                                                                                                                                                                                         <template>
  <div class="clearfix">
    <div class="clearfix">
      <Button type="primary" icon="md-download" @click="importOrder"
              v-if="isHavePermission('twoSettlement:batchCreate')">
        导入结算信息
      </Button>
      <Button type="primary" style="margin-left: 10px;" @click="commitAllDelete()"
              v-if="isHavePermission('twoSettlement:delete')"><i
          class="el-icon-delete" style="margin-right: 10px;"></i>批量删除
      </Button>
      <!-- <vxe-button icon="vxe-icon--refresh" @click="getRecList" style="margin-left: 10px">刷新</vxe-button> -->
      <Button icon="md-refresh" @click="getRecList" style="margin-left: 10px"
      >刷新
      </Button>
      <Button icon="md-download" @click="download" style="margin-left: 10px"
              v-if="isHavePermission('twoSettlement:exportSettlementList')">导出
      </Button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form
                :data="searchFormData"
                title-align="left"
            >
              <vxe-form-item title="搜索" field="paymentsNum" span="24"
                             :prefix="{icon: 'fa fa-address-card-o'}"></vxe-form-item>
              <vxe-form-item title="结算编号" field="paymentsNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.paymentsNum" placeholder="输入结算编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="结算类型" field="paymentType" span="12">
                <template v-slot>
                  <Select v-model="searchFormData.paymentType" transfer clearable>
                    <Option value=1>托运人结算</Option>
                    <Option value=2>承运人结算</Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.goodsName" placeholder="输入货名"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.carShipNum" placeholder="输入车船号 "></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起始结算时间" field="addTimeBegin" span="12">
                <template v-slot>
                  <vxe-input type="date" v-model="searchFormData.addTimeBegin" placeholder="选择日期"
                             :transfer="false"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="结束结算时间" field="addTimeEnd" span="12">
                <template v-slot>
                  <vxe-input type="date" v-model="searchFormData.addTimeEnd" placeholder="选择日期"
                             :transfer="false"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单编号" field="ordersNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNum" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人名称" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFormData.buyerNameList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'buyerNameOptions','twoSettlement','searchCondition',3)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'buyerNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in buyerNameOptions" :value="option.name"
                            :key="option.id">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="平台企业" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFormData.platformCompanyIdList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'platformCompanyOptions','twoSettlement','searchCondition',1)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'platformCompanyOptions')"
                      placeholder="输入平台企业"
                  >
                    <Option v-for="option in platformCompanyOptions" :value="option.id"
                            :key="option.id">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人名称" field="sellerIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFormData.sellerNameList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'sellerNameOptions','twoSettlement','searchCondition',4)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'sellerNameOptions')"
                      placeholder="输入承运人"
                  >
                    <Option v-for="option in sellerNameOptions" :value="option.name"
                            :key="option.id">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFormData.createUserIdList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'createUserOptions','twoSettlement','searchCondition',7)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserOptions')"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserOptions" :value="option.id"
                            :key="option.id">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.createTime" :options="timeOptions" clearable
                              placeholder="选择时间"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px;">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal class="timeModal" v-model="open" width="460" height="400" :show-footer="false" :showHeader="false">
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix" style="margin-top: 10px">
      <vxe-table
          class="table-style"
          stripe
          show-footer
          highlight-hover-row
          max-height="540"
          border="none"
          align="center"
          :loading="loading"
          :data="orderListData"
          :footer-method="footerMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          resizable
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                trigger="click"
                style="margin-left: 10px;cursor: pointer;"
                transfer
                v-if="
                isHavePermission('twoSettlement:delete') ||
                isHavePermission('twoSettlement:update')
              "
            >
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      @click="editReceiving(row)"
                      v-if="isHavePermission('twoSettlement:update')"
                  >编辑
                  </Button
                  >
                  <Button
                      class="button-gengduo"
                      style="color: #ed4014"
                      v-if="isHavePermission('twoSettlement:delete') && row.isCanDelete === 1"
                      @click="delReceiving(row)"
                  >删除
                  </Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="paymentsNum"
            title="结算编号"
            width="160"
            show-overflow
        >
          <template slot-scope="{ row }">
            <span
                @click="openReceivingDeail(row)"
                style="cursor: pointer; color: #2d8cf0"
            >{{ row.paymentsNum }}</span
            >
          </template>
        </vxe-table-column>

        <vxe-table-column
            field="paymentType"
            title="结算类型"
            width="105"
            show-overflow
        >
          <template v-slot="{row}">
            <span>{{ row.paymentType | receiveTypeRule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="结算时间" width="110">
          <template slot-scope="{ row }">
            <span>{{ row.addTime | timePartRule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsName"
            title="货名"
            width="105"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="goodsUnit"
            title="单位"
            width="80"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="realCount"
            title="实际数量"
            width="150"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120"></vxe-table-column>
        <vxe-table-column
            field="totalAmount"
            title="结算金额"
            width="150"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="note"
            title="摘要"
            width="130"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="remark"
            title="备注"
            width="130"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="ordersNum"
            title="订单编号"
            width="130"
            show-overflow
        >
          <template slot-scope="{ row }">
            <!--            <a-->
            <!--                @click="openOrderDetail(row.ordersBuyerId, 1)"-->
            <!--            >{{ row.ordersNum }}</a-->
            <!--            >-->
            <span>{{ row.ordersNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            min-width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="compName"
            title="平台企业"
            width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            min-width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="创建人"
            width="130"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="110"
                          v-if="isHavePermission('twoSettlement:createTime')">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{
                row.createTime | timePartRule
              }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalResult"
          @page-change="handleCurrentChange"
      ></vxe-pager>
    </div>
    <edit-receiving
        ref="editReceiving"
        @updateList="updateList"
    ></edit-receiving>
    <vxe-modal
        v-model="createReceivingModal"
        title="导入结算信息"
        width="1300"
        top="150"
        position="center"
        height="660"
        resize
        destroy-on-close
        remember
    >
      <import-receiving
          @createCommit="createCommit"
      ></import-receiving>
    </vxe-modal>

    <vxe-modal
        v-model="receivingDeailModal"
        width="1300"
        title="结算详情"
        showFooter
        height="700"
        position="center"
    >
      <p slot="title" class="box-tit-211130">
        <span>结算信息</span>
      </p>
      <receiving-detail ref="receivingDetail"></receiving-detail>
      <div slot="footer">
        <vxe-button
            type="submit"
            status="primary"
            @click="delReceiving(editRows)"
            v-if="isHavePermission('twoSettlement:delete') && editRows.isCanDelete === 1"
            style="width: 140px; border-radius: 0px"
        >删除
        </vxe-button
        >
        <vxe-button
            type="submit"
            status="primary"
            @click="editReceiving(editRows)"
            v-if="isHavePermission('twoSettlement:update')"
            style="width: 140px; border-radius: 0px; margin-left: 10px"
        >编辑
        </vxe-button
        >
      </div>
    </vxe-modal>
    <vxe-modal
        position="center"
        v-model="templateVisible"
        title="结算信息导入"
        width="1000"
        height="620"
        @close="closeTemplate"
        remember
    >
      <import
          @goImport="goImport"
          @close="closeTemplate"
          ref="modalTemplate"
      ></import>
    </vxe-modal>
    <vxe-modal v-model="receivingModal" width="1300" height="700" position="center" :title="title" destroy-on-close>
      <receiving-detail-new ref="receivingDetailNew" @afterSave="afterSave"></receiving-detail-new>
    </vxe-modal>
  </div>
</template>

<script>
import XEUtils from "xe-utils/methods/xe-utils";
import $C from "@/consts";
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import ReceivingDetail from "@/components/order2.0/Receiving/ReceivingDetail";
import EditReceiving from "@/components/order2.0/Receiving/EditReceiving";
import Import from "@/components/common/Import"; // 导入
import {searchTime, SEARCH_TIME} from "@/filters/time";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import moment from "moment";
import receivingDetailNew from "@/components/subOrder/ReceivingDetail";

moment.locale("zh-CN");
import getAuthOrization from "@/mixin/getAuthOrization";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import {getBlob, postBlob, hideLoading, isEmpty, saveBlob, showLoading} from "@/utils/util";
import ImportReceiving from "@/components/order2.0/Receiving/ImportReceiving";
import {numberToCurrency} from "@/filters/type";

export default {
  components: {
    ReceivingDetail,
    ImportReceiving,
    Import,
    EditReceiving,
    receivingDetailNew
  },
  mixins: [getAuthOrization, viewOrderDetail],
  data() {
    return {
      title: '结算详情',
      receivingModal: false,
      searchLoading: false,
      detailData: {},
      open: false,
      searchVisible: false,
      searchBuyerName: [],
      searchCompName: [],
      buyerNameOptions: [],
      platformCompanyOptions: [],
      createUserOptions: [],
      compNameOptions: [],
      sellerNameOptions: [],
      fileOptions: $C.HAS_FILE_TYPE.options,
      timeOptions: SEARCH_TIME.options,
      logisticsShowData: [],
      currentPage2: 1,
      pageSize2: 5,
      totalResult2: 300,
      editRows: {},
      showImport: false,
      loading: false,
      templateVisible: false,
      trackFlag: false,
      orderTypeTwo: 1,
      orderNum: null,
      clearLogistics: null,
      deailReceiveNum: null,
      deailCreateUser: null,
      deailCreateTime: null,
      editUuidList: [],
      totalRealCounts: 0,
      totalReceAmount: 0,
      logisticDetailVisible: false,
      orderTableData: [],
      receivingTableData: [],
      logisticsTableData: [],
      createReceivingModal: false,
      editReceivingModal: false,
      isShowSearch: false,
      isShowFilter: false,
      orderListData: [],
      receivingDeailModal: false,
      currentPage: 1,
      pageSize: 10,
      totalResult: 300,
      orderType: 1,
      isIncludedTax: null,
      searchFormData: {
        addTimeBegin: null,
        addTimeEnd: null,
        chainNum: null,
        compName: null,
        createTime: null,
        buyerName: null,
        createUser: null,
        goodsName: null,
        logisticsNum: null,
        ordersNum: null,
        receiveName: null,
        receiveNum: null,
        receiveType: null,
        updateUser: null,
        hasFile: null
      },
      records: [],
      showPicIndex: 0,
      searchFormItems: [
        {
          title: "搜索",
          span: 24,
          titleAlign: "left",
          titleWidth: 200,
          titlePrefix: {icon: "fa fa-address-card-o"},
        },
        {
          field: "paymentsNum",
          title: "结算确认编号",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
        },
        {
          field: "goodsName",
          titleAlign: "left",
          title: "货名",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入货名"}},
        },
        {
          field: "addTimeBegin",
          titleAlign: "left",
          title: "起始结算时间",
          span: 12,
          itemRender: {
            name: "$input",
            props: {type: "date", placeholder: "请选择日期", transfer: false},
          },
        },
        {
          field: "addTimeEnd",
          titleAlign: "left",
          title: "结束结算时间",
          span: 12,
          itemRender: {
            name: "$input",
            props: {type: "date", placeholder: "请选择日期", transfer: false},
          },
        },
        {
          field: "chainNum",
          titleAlign: "left",
          title: "总订单编号",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
        },
        {
          field: "ordersNum",
          titleAlign: "left",
          title: "托运人订单编号",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
        },
        {
          field: "buyerName",
          titleAlign: "left",
          title: "托运人名称",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入名称"}},
        },
        {
          field: "compName",
          titleAlign: "left",
          title: "所属公司",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "请输入公司"}},
        },
        {
          field: "createUser",
          titleAlign: "left",
          title: "创建人",
          span: 12,
          itemRender: {
            name: "$input",
            props: {placeholder: "请输入创建人"},
          },
        },
        {
          field: "time",
          title: "按创建时间",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "请选择时间", transfer: false},
            options: SEARCH_TIME.options,
          },
        },
        {
          field: "hasFile",
          title: "附件筛查",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "请选择是否包含附件", transfer: false},
            options: $C.HAS_FILE_TYPE.options,
          },
        },
        {
          align: "center",
          span: 24,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [
              {props: {type: "submit", content: "提交", status: "primary"}},
              {props: {type: "reset", content: "重置"}},
            ],
          },
        },
      ],
      isShowPicBox: false,
      listQuery: {
        page: 1,
        rows: 10,
        orderBy: 2,
        isDesc: 1,
        addTimeBegin: null,
        addTimeEnd: null,
        chainNum: null,
        compName: null,
        createTimeBegin: null,
        createTimeEnd: null,
        createUser: null,
        goodsName: null,
        logisticsNum: null,
        ordersNum: null,
        receiveName: null,
        receiveNum: null,
        receiveType: null,
        updateUser: null,
      },
      amount: {
        totalRealCounts: 0,
        totalReceAmount: 0,
      },
      receFileList: [],
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      uploadList: [],
      file: null, // 上传
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
    };
  },
  filters: {
    receiveTypeRule(p) {
      if (p == 1) {
        return "托运人结算";
      } else if (p == 2) {
        return "承运人结算";
      }
    },
    timeRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();
        var h = "0" + timeB.getHours();
        var f = "0" + timeB.getMinutes();
        var s = "0" + timeB.getSeconds();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length) +
            " " +
            h.substring(h.length - 2, h.length) +
            ":" +
            f.substring(f.length - 2, f.length) +
            ":" +
            s.substring(s.length - 2, s.length)
        );
      } else {
        return "";
      }
    },
    // 时间显示part（年月日）
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
    // 时间显示part（时分秒）
    timeSfmRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var h = "0" + timeB.getHours();
        var f = "0" + timeB.getMinutes();
        var s = "0" + timeB.getSeconds();
        return (
            h.substring(h.length - 2, h.length) +
            ":" +
            f.substring(f.length - 2, f.length) +
            ":" +
            s.substring(s.length - 2, s.length)
        );
      } else {
        return "";
      }
    },
  },
  watch: {
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  created() {
    this.$bus.$on("结算2.0", () => {
      this.reset();
      this.getSearchListKey();
    });
    this.$bus.$on("isShowBigPic", (data) => {
      this.isShowPicBox = data;
    });
  },
  mounted() {
    this.getRecList();
    this.getDicDate();
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    createCommit(val) {
      this.createReceivingModal = val;
      this.getRecList();
    },
    reset() {
      this.searchFormData = {
        addTimeBegin: null,
        addTimeEnd: null,
        chainNum: null,
        compName: null,
        createTime: null,
        buyerName: null,
        createUser: null,
        goodsName: null,
        logisticsNum: null,
        ordersNum: null,
        receiveName: null,
        receiveNum: null,
        receiveType: null,
        updateUser: null,
        hasFile: null
      }
      this.searchBuyerName = [];
      this.searchCompName = [];
    },
    async getDicDate() {
      let res = await $api.dict.post("queryDictByCode", {
        id: 205
      });
      if (res.status === 1) {
        this.orderFileUrl = res.data.iconUrl
      }
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
      };

      if (!isEmpty(query)) {
        params.name = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i)
          }
        })
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    inputcounts(row) {
      if (row.counts) {
        if (row.price) {
          row.receAmount = Math.round(row.counts * row.price * 100) / 100;
        }
      }
    },
    getSearchListKey() {
      // this.listQuery = obj;
      // this.listQuery.page = 1;
      // this.listQuery.rows = 10;
      let obj = this.searchFormData;
      let paramsObj = {};
      this.currentPage = 1;
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "time") {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }

      });
      paramsObj.page = 1;
      paramsObj.rows = 10;
      if (this.searchBuyerName.length > 0) {
        paramsObj.buyerName = this.searchBuyerName[0];
      }
      if (this.searchCompName.length > 0) {
        paramsObj.compName = this.searchCompName[0];
      }
      this.listQuery = paramsObj;
      if (obj.addTimeBegin) {
        this.listQuery.addTimeBegin = this.$utils.timestamp(obj.addTimeBegin);
      }
      if (obj.addTimeEnd) {
        this.listQuery.addTimeEnd = this.$utils.timestamp(obj.addTimeEnd);
      }

      this.getRecList();
      this.searchVisible = false;
    },
    async download() {
      if (isEmpty(this.orderListData)) {
        this.$XModal.message("暂无数据")
        return
      }
      let params = this.listQuery
      params.receiveType = 1
      showLoading()
      let res = postBlob("/api/order/twoSettlement/settlement/exportSettlementList", params);
      hideLoading()
      await saveBlob("导出结算.xls", res.data)
    },
    updateList(val) {
      if (val) {
        this.receivingDeailModal = false;
        this.getRecList();
      }
    },

    //获取列表
    async getRecList() {
      this.loading = true;
      // let data = this.listQuery;
      let res = await $api.twoSettlement.request(
          "list",
          this.listQuery
      );
      if (res.status == 1) {
        this.orderListData = res.data.rows;
        this.totalResult = res.data.total;
        var countData = null;
        countData = JSON.parse(res.data.countData)
        if (countData != null) {
          this.amount.totalReceAmount = countData.totalAmount
          this.amount.totalRealCounts = countData.realCount
        } else {
          this.amount.totalReceAmount = null
          this.amount.totalRealCounts = null
        }
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    resetListQuery() {
      this.listQuery = {
        page: 1,
        rows: 10,
        addTimeBegin: null,
        addTimeEnd: null,
        chainNum: null,
        compName: null,
        createTimeBegin: null,
        createTimeEnd: null,
        createUser: null,
        goodsName: null,
        logisticsNum: null,
        ordersNum: null,
        receiveName: null,
        receiveNum: null,
        receiveType: null,
        updateUser: null,
      };
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getRecList();
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "单页合计";
          }
          if (["totalAmount"].includes(column.property)) {
            return numberToCurrency(this.$utils.sum(data, column.property));
          }
          if (["realCount"].includes(column.property)) {
            return numberToCurrency(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "全部合计";
          }

          if (["totalAmount"].includes(column.property)) {
            return numberToCurrency(this.amount.totalReceAmount);
          }
          if (["realCount"].includes(column.property)) {
            return numberToCurrency(this.amount.totalRealCounts);
          }
          return null;
        }),
      ];
    },
    handleCurrentChange2(val) {
      this.logisticsShowData = this.logisticsTableData.slice(
          (val.currentPage - 1) * val.pageSize,
          val.currentPage * val.pageSize
      );
      console.log(this.logisticsShowData);
    },
    editReceiving(row) {
      this.editReceivingModal = true;
      this.receivingDeailModal = false;
      this.$refs.editReceiving.editReceiving(row);
    },
    delReceiving(row) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.deleteCommit(row);
        }
      });
    },
    async deleteCommit(row) {
      var idList = [];
      idList.push(row.id);
      showLoading();
      let res = await $api.twoSettlement.request(
          "delete", {
            idList: idList,
          }
      );
      hideLoading();
      if (res.status == 1) {
        this.listQuery.page = 1;
        this.currentPage = 1;
        this.getRecList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    afterSave() {
      this.receivingModal = false;
      this.getRecList();
    },
    openReceivingDeail(row) {
      if (!this.isHavePermission('twoSettlement:detail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      if (row.ordersVersion === 4) {
        this.detailData = row;
        this.receivingModal = true;
        this.title = '结算详情';
        this.$nextTick(() => {
          this.$refs.receivingDetailNew.getReceivingDetail(row);
        })
      } else {
        this.editRows = {
          id: row.id,
          isCanDelete: row.isCanDelete
        };
        this.receivingDeailModal = true;
        // this.getReceivingDetail(row);
        this.$nextTick(() => {
          this.$refs.receivingDetail.getReceivingDetail(row);
        })
      }
    },

    // 船舶日期往前推N天
    clickEvent3(id) {
      this.$refs[id].togglePanel();
    },
    clickFile(url) {
      window.open(url);
    },
    importOrder() {
      this.$refs.modalTemplate.setExport('', '', this.orderFileUrl);
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.createReceivingModal = true;
      this.showImport = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    commitAllDelete() {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.delAllReceiving();
        }
      })
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    async delAllReceiving() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条结算信息',
          status: "error",
        });
        return
      }
      let idList = [];
      let noteList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.twoSettlement.request(
          "delete", {
            idList: idList,
          }
      );
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.records = [];
        this.listQuery.page = 1;
        this.currentPage = 1;
        this.getRecList();
      }
    },
  },
};
</script>

<style>
.my-dropdown3 {
  margin-top: 10px;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}

.fontWeight {
  font-weight: 800;
  line-height: 14px;
  margin-bottom: 10px;
  display: inline-block;
}

/* .flexButton {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
} */

.infoPaddingCss .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 0px solid #409eff;
}

/* .trackBox {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 68px;
  top: 110px;
  z-index: 999;
  background: #fff;
} */
.infoPaddingCss .vxe-input--inner {
  width: 100%;
  height: 100%;
  /* border-radius: 4px; */
  outline: 0;
  padding: 0 0.6em;
  color: #606266;
  border: 0px solid #dcdfe6;
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.button-gengduo {
  border: none;
}

.vxe-input--panel.type--date,
.vxe-input--panel.type--month,
.vxe-input--panel.type-- week,
.vxe-input--panel.type--year {
  z-index: 9998 !important;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

/* .vxe-modal--wrapper{
  top:100px
} */
.show-pic {
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.trackBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 100;
  background: #fff;
}

.pdf-box1 {
  display: inline-block;
  position: relative;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 60px;
  height: 60px;
  overflow: hidden;
}

.vxe-modal--wrapper.type--modal .vxe-modal--box {
  top: 5vh;
}

.infoPaddingCss .vxe-pager .vxe-pager--sizes {
  width: 7em;
  text-align: center;
  cursor: pointer;
  display: none;
}
</style>
